import { useGetUserProfileQuery } from '@api/index';
import { Alert } from '@mui/material';

/**
 * User Profile Loader
 */
export const UserProfileLoader = () => {
  const { data, isSuccess, isError } = useGetUserProfileQuery(null);
  return isError ? <Alert severity='error'>Something went wrong</Alert> : null;
};
